'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
var index_es = require('../node_modules/slate-react/dist/index.es.js');
require('@material-ui/core/Button');
var FormatBoldIcon = require('@material-ui/icons/FormatBold');
var FormatItalicIcon = require('@material-ui/icons/FormatItalic');
var LooksOneIcon = require('@material-ui/icons/LooksOne');
var LooksTwoIcon = require('@material-ui/icons/LooksTwo');
var FormatQuoteIcon = require('@material-ui/icons/FormatQuote');
var FormatListNumberedIcon = require('@material-ui/icons/FormatListNumbered');
var FormatListBulletedIcon = require('@material-ui/icons/FormatListBulleted');
var FormatStrikethroughIcon = require('@material-ui/icons/FormatStrikethrough');
var LinkIcon = require('@material-ui/icons/Link');
var useTextEditor = require('./useTextEditor.js');
var ActionButton = require('./ActionButton.js');
var utils = require('./utils.js');
var LinkDialog = require('./LinkDialog.js');
var links = require('./plugins/links.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var FormatBoldIcon__default = /*#__PURE__*/_interopDefaultLegacy(FormatBoldIcon);
var FormatItalicIcon__default = /*#__PURE__*/_interopDefaultLegacy(FormatItalicIcon);
var LooksOneIcon__default = /*#__PURE__*/_interopDefaultLegacy(LooksOneIcon);
var LooksTwoIcon__default = /*#__PURE__*/_interopDefaultLegacy(LooksTwoIcon);
var FormatQuoteIcon__default = /*#__PURE__*/_interopDefaultLegacy(FormatQuoteIcon);
var FormatListNumberedIcon__default = /*#__PURE__*/_interopDefaultLegacy(FormatListNumberedIcon);
var FormatListBulletedIcon__default = /*#__PURE__*/_interopDefaultLegacy(FormatListBulletedIcon);
var FormatStrikethroughIcon__default = /*#__PURE__*/_interopDefaultLegacy(FormatStrikethroughIcon);
var LinkIcon__default = /*#__PURE__*/_interopDefaultLegacy(LinkIcon);

var MARK_FORMATS = [{
  value: 'bold',
  icon: FormatBoldIcon__default['default'],
  label: 'Bold'
}, {
  value: 'italic',
  icon: FormatItalicIcon__default['default'],
  label: 'Italic'
}, {
  value: 'strikethrough',
  icon: FormatStrikethroughIcon__default['default'],
  label: 'Strikethrough'
}];
var BLOCK_FORMATS = [{
  value: 'heading-one',
  icon: LooksOneIcon__default['default'],
  label: 'Heading 1'
}, {
  value: 'heading-two',
  icon: LooksTwoIcon__default['default'],
  label: 'Heading 2'
}, {
  value: 'block-quote',
  icon: FormatQuoteIcon__default['default'],
  label: 'Quote'
}, {
  value: 'numbered-list',
  icon: FormatListNumberedIcon__default['default'],
  label: 'Numbered List'
}, {
  value: 'bulleted-list',
  icon: FormatListBulletedIcon__default['default'],
  label: 'Bulletted List'
}];
var ButtonPanel = () => {
  var [linkSelection, setLinkSelection] = React__namespace.useState(null);
  var {
    classes,
    isFocused
  } = useTextEditor.useTextEditor();
  var editor = index_es.useSlate();
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: clsx_m(classes.buttons, isFocused && classes.isFocused)
  }, MARK_FORMATS.map(mark => /*#__PURE__*/React__namespace.createElement(ActionButton.ActionButton, {
    key: mark.value,
    isActive: utils.isMarkActive(editor, mark.value),
    value: mark.value,
    label: mark.label,
    icon: mark.icon,
    onMouseDown: event => {
      event.preventDefault();
      utils.toggleMark(editor, mark.value);
    }
  })), BLOCK_FORMATS.map(block => /*#__PURE__*/React__namespace.createElement(ActionButton.ActionButton, {
    key: block.value,
    isActive: utils.isBlockActive(editor, block.value),
    value: block.value,
    label: block.label,
    icon: block.icon,
    onMouseDown: event => {
      event.preventDefault();
      utils.toggleBlock(editor, block.value);
    }
  })), /*#__PURE__*/React__namespace.createElement(ActionButton.ActionButton, {
    icon: LinkIcon__default['default'],
    isActive: links.isLinkActive(editor),
    label: "Add Link",
    onMouseDown: event => {
      event.preventDefault();

      if (links.isLinkActive(editor)) {
        links.unwrapLink(editor);
      } else {
        setLinkSelection(editor.selection);
      }
    }
  }), /*#__PURE__*/React__namespace.createElement("div", {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/React__namespace.createElement(LinkDialog.LinkDialog, {
    isOpen: Boolean(linkSelection),
    selection: linkSelection,
    onClose: () => setLinkSelection(null)
  }));
};

exports.ButtonPanel = ButtonPanel;
